// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"c4cef2f6","455":"2dbee1d0","644":"069234ff","737":"eb2fcd48","959":"94c9cd15"}[chunkId] + ".chunk.js";
};